module.exports = __webpack_public_path__ + "static/img/img_product_phone.646bb25.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/mprodServ_h5/img_product_phone.png
// module id = Gz0P
// module chunks = 0